/** Canonical customer-facing product names (CCI branding). */
export const PRODUCT_NAMES = {
    CCI: 'CCI',
    CCI_FULL: 'Cnapse Cleanroom Intelligence (CCI)',
    INSIGHT: 'Cnapse Insight',
    FLUX: 'Cnapse Flux',
    CINI: 'Cini',
    NODE: 'Cnapse Node',
    SATELLITE: 'Cnapse Satellite',
    AXON: 'Cnapse Axon',
    MATRIX: 'Cnapse Matrix',
    /** Axon peripherals (internal keys: barcode-scanner, waferid-camera). */
    AXON_BARCODE_MODULE: 'Axon Barcode Module — Fixed',
    AXON_HANDHELD_BARCODE: 'Axon Barcode Module — Handheld',
    AXON_WAFER_ID_MODULE: 'Axon Wafer ID Module',
};
//# sourceMappingURL=product-names.js.map